import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <h1 className="text-6xl font-bold text-red-500">404</h1>
      <h2 className="text-2xl mt-4">Página no encontrada</h2>
      <p className="mt-2 text-gray-600">Lo sentimos, la página que buscas no existe.</p>
      <Link to="/" className="mt-4 px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
        Volver al inicio
      </Link>
    </div>
  );
};

export default NotFound;
